import React from 'react';
import { Button } from '../../Button';
import IconClose from '../../internal/icons/Close';
import { useTranslation } from '../../hooks/useTranslation';
export default function ClearButton(props) {
    const { t } = useTranslation('Autocomplete');
    return (React.createElement(Button, { variant: "icon", type: "tertiary", size: "small", "aria-label": t('clear'), ...props },
        React.createElement(IconClose, { "aria-hidden": true })));
}
